jQuery(document).ready(function ($) {

    // Set up our flickity slider
    var $slider = $('.four-product-slider-1__slider--manual').flickity({
        "watchCSS": true,
        "autoPlay": 5000,
        "draggable": false,
        "cellAlign": "left",
        "wrapAround": true,
        "cellSelector": ".four-product-slider-1__col",
        "groupCells": true
    });

    // Setup on click handler for tabs
    $(this).find('.application-tabs-1__navigation > *').on('click', function (e) {
        e.preventDefault();

        // Get the ID of this tabs target
        var target = $(this).data('link');

        // Remove active from all tabs and add to this one
        $(this).siblings().removeClass('is-active');
        $(this).addClass('is-active');

        // Hide all tab contents and show this one
        $(this).closest('[data-tabs]').find('[data-tab-content] > *').hide();
        $(this).closest('[data-tabs]').find('[data-tab-content] [data-content="' + target + '"]').show();

        if ( $slider.length ) {
            $slider.flickity('resize');
        }

    });

});
